module.exports = __webpack_public_path__ + "static/img/ent-60.b740430.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-60.jpg
// module id = SWzp
// module chunks = 51